import React, {useRef} from 'react';
import { appearUp } from "../SettingValues";
import AnimateDiv from '../../../Component/AnimateDiv'
import { Card } from "@material-ui/core";

import './Member.scss'

import {useOnScreen} from '../../../Hooks';
import {logBehavior} from '../../../Data/Behavior';
let didSeen = false;




const Member = () => {

    const ref = useRef();
    const onScreen = useOnScreen(ref);
    if (!didSeen && onScreen){
        didSeen = onScreen;
        logBehavior('scroll-member', {});
    }

    return (

        <div ref={ref} className={"MemberSubRoot"} id={"Member"}>
            
            <div className={"MemberTitle"}>
                <AnimateDiv variants={appearUp} >
                    <div className={"TeamTitle"}>
                        {"오늘의웹툰 팀"}
                    </div>
                </AnimateDiv>

                <AnimateDiv variants={appearUp}>
                    <div className={"TitleFlex"}>
                        <span className={"Blue"}>
                            {"데이터"}
                        </span>
                        {"를 알고 "}
                        <span className={"Blue"} >
                            {"웹툰"}
                        </span>
                        {"을 이해하는 팀이 "}
                        <span style={{whiteSpace:'nowrap'}}>{"함께 합니다."}</span>
                    
                    </div>
                </AnimateDiv>
            </div>
            <div>
                <div className={"Section"} >
                    <div className={"SeperatedSection"}>
                        <div className={"CardBox"}>
                            <AnimateDiv variants={appearUp}>
                                <Card className={"Cards"} elevation={0}>
                                    <div className={"Characters"}>
                                        <img
                                            src={"https://static.webtoon.today/ddah/sugeul.png"}
                                            alt={"진수글"}
                                            className={"CardIcon"}
                                        />
                                    </div>
                                    <div className={"Introduction"}>
                                        <div className={"JobPositions"}>
                                            <div className={"Position"}>
                                                {"대표 "}
                                            </div>
                                            <div className={"Name"}>
                                                {"진수글"}
                                            </div>
                                            <div className={"Position Hidden"}>
                                                {"대표 "}
                                            </div>
                                        </div>
                                        <div>
                                            <ul className={"UlStyles"}>
                                                <li>
                                                    <span
                                                        className={"SubText"}
                                                    >
                                                        {"'19.~'20."}
                                                    </span>
                                                    <br />
                                                    <div className={"Context"}>
                                                        {"브이로거(Vlogr) CTO"}
                                                    </div>
                                                </li>
                                                <li>
                                                    <span
                                                        className={"SubText"}
                                                    >
                                                        {"'16.~'19."}
                                                    </span>
                                                    <br />
                                                    <div className={"Context"}>
                                                        {
                                                            "네이버 검색센터 추천연구팀(AiRS) Modeler"
                                                        }
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className={"SubText"}>
                                                        {"'15.~'15."}
                                                    </span>
                                                    <br />
                                                    <div className={"Context"}>
                                                        {"Bain&Company Research Assistant"}
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className={"SubText"}>
                                                        {"'08.~'13."}
                                                    </span>
                                                    <br />
                                                    <div className={"Context"}>
                                                        {"카이스트 전산학과"}
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </Card>
                            </AnimateDiv>
                        </div>
                        <div className={"CardBox"}>
                            <AnimateDiv variants={appearUp}>
                                <Card className={"Cards"} elevation={0}>
                                    <div className={"Characters"}>
                                        <img 
                                            src={"https://static.webtoon.today/ddah/seojung.png"}
                                            alt={"김서정"}
                                            className={"CardIcon"}
                                        />
                                    </div>
                                    <div className={"Introduction"}>
                                        <div className={"JobPositions"}>
                                            <div className={"Position"}>
                                                {"디렉터 "}
                                            </div>
                                            <div className={"Name"}>
                                                {"김서정"}
                                            </div>
                                            <div className={"Position Hidden"}>
                                                {"디렉터 "}
                                            </div>
                                        </div>
                                        <div>
                                            <ul className={"UlStyles"}>
                                                <li>
                                                    <span className={"SubText"} >
                                                        {"'19.~"}
                                                    </span>
                                                    <br />
                                                    <div className={"Context"}>
                                                        {"유튜브 '두미두미의 웹툰강좌' 운영"}
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className={"SubText"}>
                                                        {"'18.~"}
                                                    </span>
                                                    <br />
                                                    <div className={"Context Multiline"}>
                                                        {"웹툰 연재"}<br/>
                                                        <div className={"SubContext"}>
                                                            {"- 피너툰 '낭만주의자와 쾌락주의자가 만났을 때'"}
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className={"SubText"}>
                                                        {"'09.~'17. "}
                                                    </span>
                                                    <br />
                                                    <div className={"Context"}>
                                                        {"윤지운 작가 어시스턴트"}
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className={"SubText"}>
                                                        {"'99.~'01. "}
                                                    </span>
                                                    <br />
                                                    <div className={"Context"}>
                                                        {"치요다 공과예술 전문학교 만화과"}
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </Card>
                            </AnimateDiv>
                        </div>
                    </div>
                    <div className={"SeperatedSection"}>
                        <div className={"CardBox"}>
                            <AnimateDiv variants={appearUp}>
                                <Card className={"Cards"} elevation={0}>
                                    <div className={"Characters"}>
                                        <img
                                            src={"https://static.webtoon.today/ddah/yeongho.png"}
                                            alt={"서영호"}
                                            className={"CardIcon"}
                                        />
                                    </div>
                                    <div className={"Introduction"}>
                                        <div className={"JobPositions"}>
                                            <div className={"Position"}>
                                                {"디렉터 "}
                                            </div>
                                            <div className={"Name"}>
                                                {"서영호 "}
                                            </div>
                                            <div className={"Position Hidden"}>
                                                {"디렉터 "}
                                            </div>
                                        </div>
                                        
                                        <div>
                                            <ul className={"UlStyles"}>
                                                <li>
                                                    <span className={"SubText"}>
                                                        {"'14.~`20. "}
                                                    </span>
                                                    <br />
                                                    <div className={"Context"}>
                                                        {"카툰팝 만화학원 강의"}
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className={"SubText"}>
                                                        {"'21. "}
                                                    </span>
                                                    <br />
                                                    <div className={"Context"}>
                                                        {"제주 웹툰 캠퍼스 출강"}
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className={"SubText"}>
                                                        {"'13.~'20. "}
                                                    </span>
                                                    <br />
                                                    <div className={"Context"}>
                                                        {"웹툰 연재"}<br />
                                                        <div className={"SubContext"}>
                                                            {"- 카카오페이지 '귀신잡는 말뚝이'"}<br />
                                                            {"- 코미코 '이매용주전'"}<br />
                                                            {"- 만화경 '교육생','페어플레이'"}
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className={"SubText"}>
                                                        {"'05.~'12. "}
                                                    </span>
                                                    <br />
                                                    <div className={"Context"}>
                                                        {"공주대 만화 애니메이션 전공"}
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </Card>
                            </AnimateDiv>
                        </div>
                        <div className={"CardBox"}>
                            <AnimateDiv variants={appearUp}>
                                <Card className={"Cards"} elevation={0}>
                                    <div className={"Characters"}>
                                        <img
                                            src={"https://static.webtoon.today/ddah/wooin.png"}
                                            alt={"심우인"}
                                            className={"CardIcon"}
                                        />
                                    </div>
                                    <div className={"Introduction"}>
                                        <div className={"JobPositions"}>
                                            <div className={"Position"}>
                                                {"디렉터 "}
                                            </div>
                                            <div className={"Name"}>
                                                {"심우인"}
                                            </div>
                                            <div className={"Position Hidden"}>
                                                {"디렉터 "}
                                            </div>
                                        </div>
                                        <div>
                                            <ul className={"UlStyles"}>
                                            </ul>
                                        </div>
                                    </div>
                                </Card>
                            </AnimateDiv>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className={"Section"} >
                    <div className={"SeperatedSection"}>
                        <div className={"CardBox"}>
                            <AnimateDiv variants={appearUp}>
                                <Card className={"Cards"} elevation={0}>
                                    <div className={"Characters"}>
                                        <img
                                            src={"https://static.webtoon.today/ddah/dongyeong.png"}
                                            alt={"김동영"}
                                            className={"CardIcon"}
                                        />
                                    </div>
                                    <div className={"Introduction"}>
                                        <div className={"JobPositions"}>
                                            <div className={"Position"}>
                                                {"프론트 "}
                                            </div>
                                            <div className={"Name"}>
                                                {"김동영"}
                                            </div>
                                            <div className={"Position Hidden"}>
                                                {"프론트 "}
                                            </div>
                                        </div>
                                        <div>
                                            <ul className={"UlStyles"}>
                                            </ul>
                                        </div>
                                    </div>
                                </Card>
                            </AnimateDiv>
                        </div>
                        <div className={"CardBox"}>
                            <AnimateDiv variants={appearUp}>
                                <Card className={"Cards"} elevation={0}>
                                    <div className={"Characters"}>
                                        <img 
                                            src={"https://static.webtoon.today/ddah/chaewon.png"}
                                            alt={"이채원"}
                                            className={"CardIcon"}
                                        />
                                    </div>
                                    <div className={"Introduction"}>
                                        <div className={"JobPositions"}>
                                            <div className={"Position"}>
                                                {"UX디자이너 "}
                                            </div>
                                            <div className={"Name"}>
                                                {"이채원"}
                                            </div>
                                            <div className={"Position Hidden"}>
                                                {"UX"}
                                            </div>
                                        </div>
                                        <div>
                                            <ul className={"UlStyles"}>
                                                <li>
                                                    <span className={"SubText"}>
                                                        {"'17.~'22. "}
                                                    </span>
                                                    <br />
                                                    <div className={"Context"}>
                                                        {"한양대학교 ERICA 문학콘텐츠학과"}
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </Card>
                            </AnimateDiv>
                        </div>
                    </div>
                    <div className={"SeperatedSection"}>
                        <div className={"CardBox"}>
                            <AnimateDiv variants={appearUp}>
                                <Card className={"Cards"} elevation={0}>
                                    <div className={"Characters"}>
                                        <img
                                            src={"https://static.webtoon.today/ddah/suhyun.png"}
                                            alt={"안수현"}
                                            className={"CardIcon"}
                                        />
                                    </div>
                                    <div className={"Introduction"}>
                                        <div className={"JobPositions"}>
                                            <div className={"Position"}>
                                                {"마케팅 "}
                                            </div>
                                            <div className={"Name"}>
                                                {"안수현 "}
                                            </div>
                                            <div className={"Position Hidden"}>
                                                {"마케팅 "}
                                            </div>
                                        </div>
                                        <div>
                                            <ul className={"UlStyles"}>
                                                <li>
                                                    <span className={"SubText"}>
                                                        {"'22. "}
                                                    </span>
                                                    <br />
                                                    <div className={"Context"}>
                                                        {"TBS 전략기획실 유튜브 콘텐츠 제작"}
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className={"SubText"}>
                                                        {"'21. "}
                                                    </span>
                                                    <br />
                                                    <div className={"Context"}>
                                                        {"서울시청 조경과 홍보콘텐츠 제작 담당"}
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className={"SubText"}>
                                                        {"'20. "}
                                                    </span>
                                                    <br />
                                                    <div className={"Context"}>
                                                        {"나스미디어 광고팀 인턴 "}<br />
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className={"SubText"}>
                                                        {"'16.~'21. "}
                                                    </span>
                                                    <br />
                                                    <div className={"Context"}>
                                                        {"한양대 ERICA 신문방송학과"}
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </Card>
                            </AnimateDiv>
                        </div>
                        <div className={"CardBox"}>
                            <AnimateDiv variants={appearUp}>
                                <Card className={"Cards"} elevation={0}>
                                    <div className={"Characters"}>
                                        <img
                                            src={"https://static.webtoon.today/ddah/sehwan.png"}
                                            alt={"손세환"}
                                            className={"CardIcon"}
                                        />
                                    </div>
                                    <div className={"Introduction"}>
                                        <div className={"JobPositions"}>
                                            <div className={"Position"}>
                                                {"백엔드 "}
                                            </div>
                                            <div className={"Name"}>
                                                {"손세환"}
                                            </div>
                                            <div className={"Position Hidden"}>
                                                {"디렉터 "}
                                            </div>
                                        </div>
                                        <div>
                                            <ul className={"UlStyles"}>
                                                <li>
                                                    <span className={"SubText"}>
                                                        {"'19.~ "}
                                                    </span>
                                                    <br />
                                                    <div className={"Context"}>
                                                        {"서울대학교 전기정보공학부"}
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </Card>
                            </AnimateDiv>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    );

}

export default Member;